var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"扫码加入班级","visible":_vm.dialogVisible,"width":"520px","center":"center"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"erweima"},[_c('img',{attrs:{"src":_vm.qr_code,"alt":""}}),_vm._v(" "),_c('div',{staticStyle:{"color":"#2881cd"}},[_vm._v("使用授课通APP扫码加入班级")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abc2a90e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Panel/banji/addClassQr.vue
// module id = null
// module chunks = 